import { useState } from "react";
import { IAllLabRequisitionItem } from "@home-health-notify/models";
import { ATTACHMENT_TYPE } from "@home-health-notify/domain";
import DocumentThumbBox from "../chatInfo/tabs/info/common/DocumentThumbBox";
import DocumentPreview from "../message/documentViewer/DocumentPreview";
import {
  ReportFileName,
  ReportRow,
  ReportsList,
} from "./LabRequisitionsTableItem.style";

type LabOrderReport =
  IAllLabRequisitionItem["labOrders"][number]["reports"][number];

const LabOrderReports = ({ reports }: { reports: LabOrderReport[] }) => {
  const [openReportUrl, setOpenReportUrl] = useState<string | null>(null);

  if (reports.length === 0) return null;

  return (
    <ReportsList>
      {reports.map(report => (
        <ReportRow
          key={report.fileUrl}
          onClick={e => {
            e.stopPropagation();
            setOpenReportUrl(report.fileUrl);
          }}
        >
          <DocumentThumbBox
            fileName={report.fileName}
            url={report.fileUrl}
            iconWidth={24}
            padding="2px"
          />
          <ReportFileName>{report.fileName}</ReportFileName>
          {report.fileType === "pdf" && openReportUrl === report.fileUrl && (
            <DocumentPreview
              url={report.fileUrl}
              onSetDocUrl={() => {}}
              docType={ATTACHMENT_TYPE.PDF}
              onAutoOpen={() => setOpenReportUrl(null)}
            />
          )}
        </ReportRow>
      ))}
    </ReportsList>
  );
};

export default LabOrderReports;
